import type { SxProps, Theme } from "@mui/material/styles";

export const COMPARISON_SX: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  flex: 1,
  minHeight: 0,
};

export const PICKERS_ROW_SX: SxProps<Theme> = {
  display: "flex",
  justifyContent: "center",
  gap: 2,
  minWidth: 0,
  pt: 0.5,
  pr: 1.5,
  pb: 1,
  pl: 0.5,
};

export const PICKER_CELL_SX: SxProps<Theme> = {
  flex: 1,
  minWidth: 0,
  maxWidth: 400,
};

export const VERSION_SELECT_SX: SxProps<Theme> = { width: "50%" };

export const PREVIEWS_SCROLL_SX: SxProps<Theme> = (theme) => ({
  flex: 1,
  minHeight: 0,
  overflowY: "scroll",
  "&::-webkit-scrollbar": {
    width: 8,
    height: 8,
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: theme.palette.divider,
    borderRadius: 4,
    border: `1px solid ${theme.palette.divider}`,
  },
});

export const PREVIEWS_ROW_SX: SxProps<Theme> = {
  display: "flex",
  justifyContent: "center",
  gap: 2,
  minWidth: 0,
  p: 0.5,
  pt: 0,
};
